import loadable from 'react-loadable';
import React from 'react';
import Loading from '../components/loading';

const loadableEmbellish = (loader: any) => {
    return loadable({
        loader,
        loading: () => <Loading />,
        timeout: 10000,
    });
};

export default [
    {
        // 公共隐私政策
        path: '/solo/privacy',
        name: 'soloPrivacy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/solo/privacy')),
    },
    {
        // 公共服务条款
        path: '/solo/policy',
        name: 'soloPolicy',
        exact: true,
        component: loadableEmbellish(() => import('../containers/solo/policy')),
    },
    {
        // 机构隐私政策
        path: '/solo/privacy/:agencyCode',
        name: 'soloPrivacyShow',
        exact: true,
        component: loadableEmbellish(() => import('../containers/solo/agencyPrivacy')),
    },
    {
        // 机构服务条款
        path: '/solo/policy/:agencyCode',
        name: 'soloPolicyShow',
        exact: true,
        component: loadableEmbellish(() => import('../containers/solo/agencyPolicy')),
    },
    {
        // 任务中心
        path: '/task',
        name: 'taskIndex',
        exact: true,
        component: loadableEmbellish(() => import('../containers/task/index')),
    },
    {
        // 任务中心
        path: '/task/:id',
        name: 'taskShow',
        exact: true,
        component: loadableEmbellish(() => import('../containers/task/detail')),
    },
    // {
    //   // 直播详情
    //   path: '/live/:id',
    //   name: 'liveShow',
    //   exact: true,
    //   component: loadableEmbellish(() => import('../containers/live/show'))
    // },
    {
        // 彩虹桥
        path: '/rainbow',
        name: 'rainbow',
        exact: true,
        component: loadableEmbellish(() => import('../containers/rainbow')),
    },
    {
        // 直播详情
        path: '/live/:id',
        name: 'liveDetail',
        exact: true,
        component: loadableEmbellish(() => import('../containers/live-detail/index')),
    },
    {
        // 直播课程详情
        path: '/live/course/:id',
        name: 'liveCourse',
        exact: true,
        component: loadableEmbellish(() => import('../containers/live-course/index')),
    },
    {
        // 我的消息列表
        path: '/notice',
        name: 'Notice',
        exact: true,
        component: loadableEmbellish(() => import('../containers/notice/index')),
    },
    {
        // 我的消息详情
        path: '/notice/:id',
        name: 'NoticeDetail',
        exact: true,
        component: loadableEmbellish(() => import('../containers/notice/detail')),
    },
    {
        // app下载
        path: '/app-download',
        name: 'appDownload',
        exact: true,
        component: loadableEmbellish(() => import('../containers/app-download')),
    },
    {
        // alpha 会员课
        path: '/alpha',
        name: 'alpha',
        exact: true,
        component: loadableEmbellish(() => import('../containers/alpha-member/index')),
    },
    {
        // alpha 会员课
        path: '/appointment',
        name: 'alpha',
        exact: true,
        component: loadableEmbellish(
            () => import('../containers/alpha-member/my-appointment/index')
        ),
    },
    {
        // alpha 班级详情
        path: '/alpha/:id',
        name: 'alpha',
        exact: true,
        component: loadableEmbellish(() => import('../containers/alpha-member/class-detail/index')),
    },
    // {
    //   // alpha列表
    //   path: "/alpha",
    //   name: "alpha",
    //   exact: true,
    //   component: loadableEmbellish(() => import("../containers/alpha/index")),
    // },
    // {
    //   // alpha详情
    //   path: "/alpha/:id",
    //   name: "alpha",
    //   exact: true,
    //   component: loadableEmbellish(() =>
    //     import("../containers/alpha/details/index")
    //   ),
    // },
    {
        // glive直播空白页
        path: '/blank/:id',
        name: 'glive-iframe',
        exact: true,
        component: loadableEmbellish(() => import('../containers/blank/index')),
    },
    // {
    //   // 我的预约
    //   path: "/appointment",
    //   name: "appointment",
    //   exact: true,
    //   component: loadableEmbellish(() =>
    //     import("../containers/alpha-appointment/index")
    //   ),
    // },
    {
        // 我的成长值
        path: '/growth',
        name: 'growth',
        exact: true,
        component: loadableEmbellish(() => import('../containers/levels/index')),
    },
    {
        // 404
        path: '/404',
        name: '404',
        exact: true,
        component: loadableEmbellish(() => import('../containers/page404')),
    },

    {
        // 课程详情
        path: '/course-detail/:id',
        name: 'courseDetail',
        exact: true,
        component: loadableEmbellish(() => import('../containers/course/course-detail')),
    },
    {
        // 课程目录
        path: '/course-catelog/:id',
        name: 'courseCatelog',
        exact: true,
        component: loadableEmbellish(() => import('../containers/course/course-catelog')),
    },
    {
        // 单课详情
        path: '/course-current/:id',
        name: 'courseCurrent',
        exact: true,
        component: loadableEmbellish(() => import('../containers/course/course-current')),
    },

    // 内测阿尔法专享课alphas
    {
        // 单课详情
        path: '/alphas',
        name: 'alphas',
        exact: true,
        component: loadableEmbellish(() => import('../containers/alphas')),
    },
    {
        // 班级详情
        path: '/grade/:id',
        name: 'grade',
        exact: true,
        component: loadableEmbellish(() => import('../containers/grade/grade')),
    },
    {
        // 直播课程详情
        path: '/course-exam/:id',
        name: 'course-exam',
        exact: true,
        component: loadableEmbellish(() => import('../containers/course-exam/index')),
    },
];
